import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,

      // 登入
      login: (user, token, refreshToken) => {
        set({
          user,
          token,
          refreshToken,
          isAuthenticated: true
        });
      },

      // 登出
      logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        set({
          user: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false
        });
      },

      // 更新使用者資訊
      updateUser: (userData) => {
        set((state) => ({
          user: { ...state.user, ...userData }
        }));
      },

      // 檢查權限
      hasPermission: (permission) => {
        const { user } = get();
        if (!user) return false;
        
        const rolePermissions = {
          admin: ['*'],
          sales: ['quotation.create', 'quotation.read', 'quotation.update', 'order.create'],
          csr: ['quotation.create', 'quotation.read', 'customer.read'],
          finance: ['quotation.read', 'order.read', 'invoice.create'],
          warehouse: ['order.read', 'shipment.create'],
        };

        const permissions = rolePermissions[user.role] || [];
        return permissions.includes('*') || permissions.includes(permission);
      },

      // 檢查角色
      hasRole: (roles) => {
        const { user } = get();
        if (!user) return false;
        
        if (Array.isArray(roles)) {
          return roles.includes(user.role);
        }
        
        return user.role === roles;
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated
      })
    }
  )
);
